import WRAP from "WRAP-JS";
/* eslint-disable */
WRAP.Data.Controller.EXPO_TileExt = (function(){

  var Cache = WRAP.Cache;
  var request = [];
  var loading = [];

  function load_level(data, e, grayscale_value) {
    return new Promise((resolve, reject) => {
      if ( data.conf.level.url.indexOf("%element%") >=0 && !e ) {
        reject();
        return;
      }
      data.control.level[e] = 'loading';
      data.load('level', {element:e}, false,
        function(value) {
          data.control.level[e] = 'loaded';
          grayscale_value[e] = value;
          resolve();
        },
        function() {
          data.control.level[e] = 'error';
          grayscale_value[e] = {};
          reject();
        }
      );
    });
  }

  function get_level(data, element, cb) {
    var ds = data.source.data;
    if ( !ds.conf.grayscale_value )
      ds.conf.grayscale_value = {};
    var elements = Array.isArray(element)?element:[element];

    return new Promise(resolve => {
      const promises = [];
      for ( var i = 0 ; i < elements.length ; i++ ) {
        var e = elements[i];
        if ( !data.control.level[e] && !ds.conf.grayscale_value[e] && data.source.level ) {
          promises.push(new Promise(resolve => {
            load_level(data, e, ds.conf.grayscale_value).then(resolve).catch(resolve);
          }));
        }
        Promise.all(promises).then(() => {
          cb && cb();
          resolve();
        });
      }
    });
  }

  function waitTimelist(data, cb) {
    if ( !data.control.timelist_wait )
      data.control.timelist_wait = [];
    data.control.timelist_wait.push(cb);
  }

  function getCache(key) {
    var cached = Cache.get(key);
    return cached && cached.data;
  }

  function setCache(key, data, size, ds, error) {
    Cache.set(key, data, size, ds, error);
  }

  function load(data_desc) {
    if ( data_desc.data )
      return;
    if ( loading[data_desc.key] )
      return;
    loading[data_desc.key] = true;
    data_desc.ds.load(data_desc.option, false,
      function(tile) {
        var data = { data:new Float32Array(65536) };
        var d = data.data;
        var s = tile.imageData.data;
        var set = new Set();
        for ( var i = 0 ; i < 65536 ; i++ ) {
          d[i] = s[i*4];
          set.add(d[i])
        }
        setCache(data_desc.key, data, 65536*4+256, data_desc.ds);
        data_desc.data = data;
        updateRequest();
        delete loading[data_desc.key];
      },
      function(data, url, status) {
        var data = { data:null };
        data_desc.error = {url:url, status:status};
        data_desc.data = data;
        updateRequest();
        delete loading[data_desc.key];
      }
    );
  }

  function updateRequest() {
    var r = [].concat(request);
    for ( var i = 0 ; i < r.length ; i++ )
      processRequest(r[i])
  }

  function processRequest(r) {
    for ( var i = 0 ; i < r.data_list.length ; i++ ) {
      var data_desc = r.data_list[i];
      if ( !data_desc.data )
        return;
    }
    for ( var i = 0 ; i < r.data_list.length ; i++ ) {
      var data_desc = r.data_list[i];
      if ( data_desc.error && r.error ) {
        r.error(data_desc.error);
        return;
      }
    }
    var result;
    if ( r.point ) {
      for ( var i = 0 ; i < r.data_list.length ; i++ ) {
        var data_desc = r.data_list[i];
        var pixel = lonLat2pixel(data_desc.lon, data_desc.lat, data_desc.tile.z);
        result = getPixelValue(data_desc.data.data, pixel);
        result = getGrayScaleValue(data_desc, result);
        if (result !== undefined) {
          break;
        }
      }
    }

    if ( r.progress )
      r.progress(1, 1, result);
    if ( r.success )
      r.success(result);
    var index = request.indexOf(r);
    if ( index >=0 )
      request.splice(index, 1);
  }

  const lonLat2tile = (
    lon,
    lat,
    zoom,
    options
  ) => {
    const {min, max} = Object.assign({}, options);
    let z = min && min > zoom ? min : max && max < zoom ? max : zoom;
    z = z > 0 ? Math.ceil(z) : 0;
    return {
      x: Math.floor(((lon + 180) / 360) * Math.pow(2, z)),
      y: Math.floor(
        ((1 -
            Math.log(
              Math.tan((lat * Math.PI) / 180) + 1 / Math.cos((lat * Math.PI) / 180)
            ) /
            Math.PI) /
          2) *
        Math.pow(2, z)
      ),
      z,
    };
  };

  const tileBaseLonLat = (x, y, z) => {
    // タイルの左上のlon,lat
    const n = Math.PI - (2 * Math.PI * y) / Math.pow(2, z);
    return [
      (x / Math.pow(2, z)) * 360 - 180,
      (180 / Math.PI) * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n))),
    ];
  };

  const lonLat2pixel = (lon, lat, zoom) => {
    let mapSize = Math.pow(2, zoom) * 256;
    const x = ((lon + 180.0) / 360.0 * (1 << zoom));
    const y = ((1.0 - Math.log(Math.tan(lat * (Math.PI / 180.0)) + 1.0 / Math.cos(lat * (Math.PI / 180.0))) / Math.PI) / 2.0 * (1 << zoom));
    const tileX = Math.trunc(x);
    const tileY = Math.trunc(y);
    const pixelX = ((tileX * 256) + ((x - tileX) * 256)) % (mapSize - 1);
    const pixelY = ((tileY * 256) + ((y - tileY) * 256)) % (mapSize - 1);

    return [
      Math.floor(pixelX - tileX * 256),
      Math.floor(pixelY - tileY * 256),
    ];
  };

  const getPixelValue = (data, pixel) => {
    const [x, y] = pixel;
    const index = y * 256 + x;
    if ( data && 0 <= index && index < 65536 ) {
      return data[index];
    }
  };

  const getGrayScaleValue = (data_desc, value) => {
    const grayscaleValue = data_desc.ds.data.conf.grayscale_value || data_desc.ds.conf.grayscale_value?.[data_desc.option.element];
    if (grayscaleValue) {
      return grayscaleValue[value];
    }
    return value;
  }

  const contain = (lon, lat, bbox) => {
    if (!bbox) {
      return true;
    }
    if (!["West", "South", "East", "North"].every(v => v in bbox)) {
      return true;
    }

    if (!(bbox.South <= lat && bbox.North >= lat)) {
      return false;
    }
    if (bbox.West <= lon && bbox.East >= lon) {
      return true
    }
    if (bbox.West + 360 <= lon && bbox.East + 360 >= lon) {
      return true;
    }
    if (bbox.West - 360 <= lon && bbox.East - 360 >= lon) {
      return true;
    }
    return false;
  }

  const makeTileKey = (ds, option, tile_id, sampling) => {
    let tile_key = ds.makeDataKey(option);
    tile_key += "/"+tile_id;
    if ( sampling )
      tile_key += "/"+sampling;
    return tile_key;
  }

  return {
    init: function(data) {
      data.control = {
        validtime_state: {
          retained:null,
          error:null,
          revision:0
        },
        extravalidtime_state: {
          retained:null,
          error:null,
          revision:0
        },
        timestamp_length:0,
        level:{}
      };
    },

    setup: function(data) {
      var region = data.source.region;
      if ( region ) {
        if ( !region.conf.update_interval )
          region.load();
        data.updated('region', function(area) {
          if ( area && area.ELON !== undefined && area.WLON !== undefined
            && area.NLAT !== undefined && area.SLAT !== undefined ) {
            if ( area.ELON == 0 && area.WLON == 0 ) {
              area.ELON = 180;
              area.WLON = -180;
            }
            var ds = data.source.data;
            if ( ds ) {
              var Grid = ds.conf.Grid;
              if ( !Grid )
                ds.conf.Grid = {};
              var BoundingBox = Grid.BoundingBox;
              if ( !BoundingBox )
                BoundingBox = Grid.BoundingBox = {};
              if ( BoundingBox.North != area.NLAT
                || BoundingBox.South != area.SLAT
                || BoundingBox.West != area.WLON
                || BoundingBox.East != area.ELON ) {
                var old = Object.assign({}, BoundingBox);
                BoundingBox.North = area.NLAT;
                BoundingBox.South = area.SLAT;
                BoundingBox.West = area.WLON;
                BoundingBox.East = area.ELON;
                //console.debug('BoundingBox updated:'+JSON.stringify(old)+" -> "+JSON.stringify(BoundingBox));
                ds.state.revision++;
                ds.data._inspector(ds);
              }
            }
          }
          else {
            console.error("EXPO_Tile region_area error:unexpected format."+JSON.stringify(area));
          }
        })
      }
      if ( data.source.data ) {
        var url = data.source.data.conf.url;
        if ( url && url.indexOf('datatime') >=0 )
          data.control.datatime = 'latest';
      }

    },

    derive: function(data, id, option, force, completed, error, progress) {
      force; error; progress;
      var ds = data.source;
      ds.timelist.load(option, false,
        function(timelist) {
          //console.log("timelist loaded")
          var validtime = [];
          var extravalidtime = [];
          for ( var i = 0 ; i < timelist.length ; i++ ) {
            var t = timelist[i].split("_");
            if ( t.length > 0 ) {
              var s = t[t.length-1];
              data.control.timestamp_length = s.length;
              if ( s.length == 20 ) { //new format '2018-09-18T01:10:00Z'
                s = s.replace(/-/g, "");
                s = s.replace(/:/g, "");
                s = s.replace(/Z/g, "");
              }
              else {
                s = s.substr(0,8) + "T" + s.substr(8,6);
                if ( s.length == 13 )
                  s += "00";
              }
              validtime.push(s);
              extravalidtime.push(timelist[i]);
            }
          }
          if ( ds.validtime ) {
            validtime.sort(
              function(a,b){
                if( a > b ) return -1;
                if( a < b ) return 1;
                return 0;
              });
            if ( data.control.datatime )
              data.control.datatime = validtime[0];
            data.control.validtime_state.retained = {validtime:validtime};
            data.control.validtime_state.error = null;
            data.control.validtime_state.revision++;
            data._update('validtime', data.control.validtime_state);
          }
          if ( ds.extravalidtime ) {
            extravalidtime.sort(
              function(a,b){
                var at = a.substr(a.length - self.satdb_timestamp_length);
                var bt = b.substr(b.length - self.satdb_timestamp_length);
                if( at > bt ) return -1;
                if( at < bt ) return 1;
                return 0;
              });
            data.control.extravalidtime_state.retained = {extravalidtime:extravalidtime};
            data.control.extravalidtime_state.error = null;
            data.control.extravalidtime_state.revision++;
            data._update('extravalidtime', data.control.extravalidtime_state);
          }
          if ( completed )
            completed(data.control.validtime_state.retained);
          data._inspector(ds.validtime);
          for ( var i = 0 ; i < ds.validtime.inspector.completed.length ; i++ )
            ds.validtime.inspector.completed[i](data.retained.validtime);
          ds[id].autoUpdate();
          if ( data.control.timelist_wait ) {
            while ( data.control.timelist_wait.length ) {
              data.control.timelist_wait[0](data);
              data.control.timelist_wait.splice(0,1);
            }
          }
        },
        function() {
          data.control.validtime_state.retained = null;
          data.control.validtime_state.error = "error";
          data.control.validtime_state.revision++;
          data._update('validtime', data.control.validtime_state);
          data.control.extravalidtime_state.retained = null;
          data.control.extravalidtime_state.error = "error";
          data.control.extravalidtime_state.revision++;
          data._update('extravalidtime', data.control.extravalidtime_state);
          if ( completed )
            completed(null);
          ds[id].autoUpdate();
          if ( data.control.timelist_wait )
            data.control.timelist_wait = undefined;
        }
      );
    },

    override: function(data, id, option) {
      if ( id == 'data' ) {
        var modified = {};
        for ( var key in option ) {
          var v = option[key];
          if ( key == 'validtime' ) {
            var v = option.validtime;
            if ( v.length == 15 ) {
              if ( data.control.timestamp_length == 12 )
                v = v.substr(0,8)+v.substr(9,4);
              else if ( data.control.timestamp_length == 14 )
                v = v.substr(0,8)+v.substr(9,6);
              else if ( data.control.timestamp_length == 20 ) //new format '2018-09-18T01:10:00Z'
                v = v.substr(0,4)+'-'+v.substr(4,2)+'-'+v.substr(6,2)+'T'+v.substr(9,2)+':'+v.substr(11,2)+':'+v.substr(12,2)+'Z';
            }
          }
          modified[key] = v;
        }
        return modified;
      }
      return option;
    },

    getTileImage: function(data, id, tile, option, sampling, success, error, progress, key) {
      if ( data.source.timelist && !data.control.timestamp_length ) {
        waitTimelist(data, function() {
          option = WRAP.Data.Controller.EXPO_Tile.override(data, id, option);
          WRAP.Data.Provider.TMS.getTileImage(data.source[id], tile, option, sampling, success, error, progress, key);
        })
        return;
      }
      WRAP.Data.Provider.TMS.getTileImage(data.source[id], tile, option, sampling, success, error, progress, key);
    },

    getTileValue: function(data, id, tile, option, sampling, success, error, progress, key) {
      if ( data.source.timelist && !data.control.timestamp_length ) {
        waitTimelist(data, function() {
          option = WRAP.Data.Controller.EXPO_Tile.override(data, id, option);
          WRAP.Data.Controller.EXPO_Tile.getTileValue(data, id, tile, option, sampling, success, error, progress, key);
        })
        return;
      }
      get_level(data, option.element, function() {
        data.source[id].getTileValue(tile, option, sampling, success, error, progress, key);
      });
    },

    getGridValue: function(data, id, bounds, option, sampling, success, error, progress, key) {
      if ( data.source.timelist && !data.control.timestamp_length ) {
        waitTimelist(data, function() {
          option = WRAP.Data.Controller.EXPO_Tile.override(data, id, option);
          WRAP.Data.Controller.EXPO_Tile.getGridValue(data, id, bounds, option, sampling, success, error, progress, key);
        })
        return;
      }
      get_level(data, option.element, function() {
        data.source[id].getGridValue(bounds, option, sampling, success, error, progress, key);
      });
    },

    getPointValue: async function(data, id, pos, option, sampling, success, error, progress, key) {
      if (!data.conf.grayscale_value && data.conf.level) {
        await get_level(data, option.element);
      }
      var lon = 1*pos[0];
      var lat = 1*pos[1];

      var ds = data.source[id];
      var g = ds.conf.Grid;
      var ycoordinate = (g.YCoordinate&&g.YCoordinate<0)?-1:1;
      var z = g.MaxZoom;
      var band = Math.pow(2,z);

      var req = {
        key:key,
        point:[lon,lat],
        sampling:sampling,
        data_list:[]
      }

      var wait = [];

      if (contain(lon, lat, g.BoundingBox)) {
        var tile = lonLat2tile(lon, lat, z);
        var min_x = tile.x;
        var max_x = tile.x;
        var min_y = tile.y;
        var max_y = tile.y;
        if ( min_y < 0 )
          min_y = 0;
        if ( max_y >= band/2 )
          max_y = band/2-1;
        req.z = z;
        req.min_x = min_x;
        req.max_x = max_x;
        req.min_y = min_y;
        req.max_y = max_y;

        for ( var y = min_y ; y <= max_y ; y++ ) {
          var yi = ycoordinate>0?(band/2-1-y):y;
          for ( var x = min_x ; x <= max_x ; x++ ) {
            var xi = x;
            var tile_key = makeTileKey(ds, option, `${z}/${yi}/${xi}`, sampling);
            var data_desc = {
              ds:ds,
              key:tile_key,
              option: {
                ...option,
                z:z,
                y:yi,
                x:xi
              },
              lat:lat,
              lon:lon,
              tile:tile,
              data:getCache(tile_key)
            }
            req.data_list.push(data_desc);
            if ( !data_desc.data )
              wait.push(data_desc);
          }
        }
      }

      req.success = success;
      req.error = error;
      req.progress = progress;
      request.push(req);
      if ( !wait.length ) {
        processRequest(req);
        return;
      }
      for ( var i = 0 ; i < wait.length ; i++ )
        load(wait[i]);
    },

    modifyContent: function(data, option) {
      if ( option ) {
        if (data.control.datatime && option.validtime ) {
          option.datatime = data.control.datatime;
          return true;
        }
        if ( option.datatime ) {
          option.datatime = undefined;
          return true;
        }
      }
    }

  }
}());
/* eslint-enable */